import { getStorageKey } from "../../utils/localStorageStateUniqueKeyGenerator.js";
export const handleUserNameValueChange = (
  value,
  setUserNameValue,
  currentContextType,
  validateUserNameValue,
  setUserNameValidationRules,
  setUserNameToolTipVisible,
  userNameValueError,
  setUserNameValueError
) => {
  setUserNameValue(value);
  // Generate a unique local storage key based on the current context
  const key = getStorageKey("userNameValue", currentContextType);
  localStorage.setItem(key, value);
  const userNameValidationResults = validateUserNameValue(value);
  setUserNameValidationRules(userNameValidationResults); // Update validation rules state
  setUserNameToolTipVisible(
    !userNameValidationResults.every((rule) => rule.isValid)
  ); // Update tooltip visibility
  if (userNameValueError) {
    setUserNameValueError("");
  }
};
export const handlefirstNameValueChange = (
  value,
  currentContextType,
  setFirstNameValue,
  firstNameValueError,
  setFirstNameValueError
) => {
  setFirstNameValue(value);
  // Generate a unique local storage key based on the current context
  const key = getStorageKey("firstNameValue", currentContextType);
  localStorage.setItem(key, value);
  if (firstNameValueError) {
    setFirstNameValueError("");
  }
};

// Function to handle changes in the lastName field
export const handleLastNameChange = (
  value,
  lastNameValueError,
  currentContextType,
  setLastNameValue,
  getStorageKey,
  setLastNameValueError
) => {
  setLastNameValue(value);
  // Generate a unique local storage key based on the current context
  const key = getStorageKey("lastNameValue", currentContextType);
  localStorage.setItem(key, value);
  if (lastNameValueError) {
    setLastNameValueError("");
  }
};
export const handleEmailChange = (
  value,
  setEmailValue,
  currentContextType,
  getStorageKey,
  emailValueError,
  setEmailValueError
) => {
  setEmailValue(value);
  const key = getStorageKey("emailValue", currentContextType);
  localStorage.setItem(key, value);
  if (emailValueError) {
    setEmailValueError("");
  }
};
export const handlePhoneInputChange = (
  value,
  setAcctPhoneNumberValue,
  currentContextType,
  getStorageKey,
  phoneNumberValueError,
  setPhoneNumberValueError
) => {
  setAcctPhoneNumberValue(value);
  const Key = getStorageKey("phoneNumberValue", currentContextType);
  localStorage.setItem(Key, value);
  if (phoneNumberValueError) {
    setPhoneNumberValueError("");
  }
};
export const handleCurrentPasswordValueChange = (
  value,
  setCurrentPasswordValue,
  currentContextType,
  getStorageKey,
  validatePasswordValue,
  setPasswordValidationRules,
  setCurrentPasswordToolTipVisible,
  currentPasswordValueError,
  setCurrentPasswordValueError
) => {
  setCurrentPasswordValue(value);
  const key = getStorageKey("currentPasswordValue", currentContextType);
  localStorage.setItem(key, value);
  const currentPasswordValidationResults = validatePasswordValue(value);
  setPasswordValidationRules(currentPasswordValidationResults);
  setCurrentPasswordToolTipVisible(
    !currentPasswordValidationResults.every((rule) => rule.isValid)
  );
  if (currentPasswordValueError) {
    setCurrentPasswordValueError("");
  }
};
/// start here
export const handleNewPasswordChange = (
  value,
  newPasswordValueError,
  currentContextType,
  setNewPasswordValue,
  validatePasswordValue,
  setNewPasswordValidationRules,
  setNewPasswordToolTipVisible,
  setNewPasswordValueError
) => {
  setNewPasswordValue(value);
  const Key = getStorageKey("newPasswordValue", currentContextType);
  localStorage.setItem(Key, value);
  const validationResults = validatePasswordValue(value);
  setNewPasswordValidationRules(validationResults);
  setNewPasswordToolTipVisible(
    !validationResults.every((rule) => rule.isValid)
  );
  if (newPasswordValueError) {
    setNewPasswordValueError("");
  }
};
export const onNewPasswordValueFocused = (
  newPasswordValue,
  validatePasswordValue,
  setNewPasswordValueFocused,
  setNewPasswordValidationRules,
  setNewPasswordToolTipVisible
) => {
  setNewPasswordValueFocused("newPasswordValue");
  setNewPasswordValueFocused(true);
  const newPasswordValidationResults = validatePasswordValue(
    newPasswordValue
  ).map((rule) => ({
    ...rule,
    isValid: rule.isValid,
  }));
  setNewPasswordValidationRules(newPasswordValidationResults);
  setNewPasswordToolTipVisible(
    newPasswordValidationResults.some((rule) => !rule.isValid)
  );
};
export const onNewPasswordValueBlur = (
  setNewPasswordValueFocused,
  setNewPasswordToolTipVisible
) => {
  setNewPasswordValueFocused(false);
  setNewPasswordToolTipVisible(false);
};
export const handleConfirmPasswordChange = (
  value,
  confirmPasswordValueError,
  currentContextType,
  setConfirmPasswordValue,
  setConfirmPasswordValueError
) => {
  setConfirmPasswordValue(value);
  const confirmPasswordKey = getStorageKey(
    "confirmPasswordValue",
    currentContextType
  );
  localStorage.setItem(confirmPasswordKey, value);
  if (confirmPasswordValueError) {
    setConfirmPasswordValueError("");
  }
};
// Adjust onFocus and onBlur for the password input
export const onCurrentPasswordValueFocused = (
  currentPasswordValue,
  validatePasswordValue,
  setCurrentPasswordValueFocused,
  setPasswordValidationRules,
  setCurrentPasswordToolTipVisible
) => {
  setCurrentPasswordValueFocused("currentPasswordValue");
  setCurrentPasswordValueFocused(true);
  // Validate the current password value
  const currentPasswordRules = validatePasswordValue(currentPasswordValue).map(
    (rule) => ({ ...rule, isValid: rule.isValid })
  );
  setPasswordValidationRules(currentPasswordRules);
  // Show the tooltip if any rule is not valid
  setCurrentPasswordToolTipVisible(
    currentPasswordRules.some((rule) => !rule.isValid)
  );
};
export const onCurrentPasswordValueBlur = (
  setCurrentPasswordValueFocused,
  setCurrentPasswordToolTipVisible
) => {
  setCurrentPasswordValueFocused(false);
  setCurrentPasswordToolTipVisible(false);
};
export const onUserNameValueFocused = (
  userNameValue,
  validateUserNameValue,
  setUserNameValueFocused,
  setUserNameValidationRules,
  setUserNameToolTipVisible
) => {
  setUserNameValueFocused("userNameValue");
  setUserNameValueFocused(true);
  const userNameRules = validateUserNameValue(userNameValue).map((rule) => ({
    ...rule,
    isValid: rule.isValid,
  }));
  setUserNameValidationRules(userNameRules);
  setUserNameToolTipVisible(userNameRules.some((rule) => !rule.isValid));
};
export const onUserNameValueBlur = (
  setUserNameValueFocused,
  setUserNameToolTipVisible
) => {
  setUserNameValueFocused(false);
  setUserNameToolTipVisible(false);
};
export const handleOriginalPasswordChange = (
  value,
  originalPasswordValueError,
  currentContextType,
  setOriginalPasswordValue,
  validatePasswordValue,
  setOriginalPasswordValidationRules,
  setOriginalPasswordToolTipVisible,
  setOriginalPasswordValueError
) => {
  setOriginalPasswordValue(value);
  const Key = getStorageKey("originalPasswordValue", currentContextType);
  localStorage.setItem(Key, value);
  const validationResults = validatePasswordValue(value);
  setOriginalPasswordValidationRules(validationResults);
  setOriginalPasswordToolTipVisible(
    !validationResults.every((rule) => rule.isValid)
  );
  if (originalPasswordValueError) {
    setOriginalPasswordValueError("");
  }
};
export const onOriginalPasswordValueFocused = (
  originalPasswordValue,
  validatePasswordValue,
  setOriginalPasswordValueFocused,
  setUserNameValueFocused,
  setOriginalPasswordValidationRules,
  setOriginalPasswordToolTipVisible
) => {
  setUserNameValueFocused("originalPasswordValue");
  setOriginalPasswordValueFocused(true);
  const originalPasswordValidationResults = validatePasswordValue(
    originalPasswordValue
  ).map((rule) => ({
    ...rule,
    isValid: rule.isValid,
  }));
  setOriginalPasswordValidationRules(originalPasswordValidationResults);
  setOriginalPasswordToolTipVisible(
    originalPasswordValidationResults.some((rule) => !rule.isValid)
  );
};
export const onOriginalPasswordValueBlur = (
  setOriginalPasswordValueFocused,
  setOriginalPasswordToolTipVisible
) => {
  setOriginalPasswordValueFocused(false);
  setOriginalPasswordToolTipVisible(false);
};
